export function getSkipIntroEndTime(
  getMetaData
) {
  const metaData = getMetaData()
  const cuePoints = metaData.cuePoints
  const skipIntroEnd = cuePoints.find(cp => cp.name === 'skip_intro_end')

  return skipIntroEnd?.time
}
